import React, { useEffect, useState } from 'react';

import Text from '@amzn/meridian/text';
import AppliedFilterTags from 'src/components/shared/appliedFilterTags/appliedFilterTags';
import LoadingSpinner from 'src/components/shared/loadingSpinner/loadingSpinner';
import PaginationWithDropdown from 'src/components/shared/paginationWithDropdown/paginationWithDropdown';
import { getJobs, setSearchField } from 'src/store/jobConfigPageSlice/jobConfigPageSlice';
import { setCurrentPage, setPerPage } from 'src/store/jobConfigPageSlice/jobConfigPageSlice';
import { removeTagAndUpdateFilter } from 'src/store/jobConfigPageSlice/jobConfigPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

import './jobConfigurationPanel.scss';

import ExportJobsSummaryModal from './exportJobsSummaryModal/exportJobsSummaryModal';
import JobConfigFilterSheet from './jobConfigFilterSheet/jobConfigFilterSheet';
import JobTable from './jobTable/jobTable';
import TopOptions from './topOptions/topOptions';

const JobConfigurationPanel = () => {
  const dispatch = useAppDispatch();
  const { userLoading } = useAppSelector((state) => state.user);
  const { jobConfigTableFilterTags, isLoading, currentPage, totalPages, perPage } = useAppSelector(
    (state) => state.jobConfigPage,
  );

  const [jobsSummaryExportModalOpen, setJobsSummaryExportModalOpen] = useState(false);

  // On Load
  useEffect(() => {
    if (userLoading === 'fulfilled') {
      dispatch(getJobs());
    }
    return () => {
      dispatch(setSearchField(''));
    };
  }, [userLoading]);

  // Return
  return (
    <div className="job-config">
      <Text className="job-config__content__text">Here you can view, edit, and add new jobs within the RTW tool</Text>
      {!isLoading ? (
        <>
          <AppliedFilterTags
            filterTags={jobConfigTableFilterTags}
            onDismissTag={(tag) => dispatch(removeTagAndUpdateFilter(tag))}
            tag-data-testid="job-config-table__applied-filter-tag"
          />
          <TopOptions onClickExportSummary={() => setJobsSummaryExportModalOpen(true)} />
          <JobTable />
          <PaginationWithDropdown
            currentPage={currentPage}
            totalPages={totalPages}
            perPage={perPage}
            setPerPage={(newPerPage) => dispatch(setPerPage(newPerPage))}
            setCurrentPage={(newPage) => dispatch(setCurrentPage(newPage))}
          />
          <ExportJobsSummaryModal
            isOpen={jobsSummaryExportModalOpen}
            onClose={() => setJobsSummaryExportModalOpen(false)}
          />
        </>
      ) : (
        <LoadingSpinner />
      )}
      <JobConfigFilterSheet />
    </div>
  );
};

export default JobConfigurationPanel;
